module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10061.89db1c83.jpg";